import React, { useEffect, useState, useRef } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { useSelector, useDispatch } from "react-redux";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "../../../../shadcn/components/ui/input-otp";
import {
  emailLoginWithOtp,
  getBidderOnboardingOfUser,
  getUser,
  intiateEmailLoginWithOtp,
  mobileLoginWithOtp,
} from "services";
import { useRouter } from "next/router";
import {
  setBidderOnboarding,
  setBidderTokens,
  setBidderUser,
  setOnboarding,
  setUser,
} from "store";

interface BidderOTPInputProps {
  userLoggedIn?: any;
  setInputModalOpen: any;
  inputModalOpen: any;
  formData: any;
}

export default function BidderOTPInput({
  userLoggedIn = false,
  setInputModalOpen,
  inputModalOpen,
  formData,
}: BidderOTPInputProps) {
  const router = useRouter();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const isSubmittingRef = useRef(false);

  useEffect(() => {
    return () => {
      isSubmittingRef.current = false;
    };
  }, []);
  const emailRegEx: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const mobileNumberRegEx: RegExp = /^[0-9]{10}$/;

  const form = useBetaForm({
    user_identity: formData.getField("user_identity") || "",
    token: "",
  });

  let guestUser = useSelector((state: any) => {
    return state.auth.guestUser;
  });
  const [timer, setTimer] = useState(60);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const form_constraints = {
    user_identity: {
      presence: {
        allowEmpty: false,
      },
    },
    token: {
      presence: {
        allowEmpty: false,
        message: "^OTP can't be blank",
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  useEffect(() => {
    let countdown: NodeJS.Timeout | null = null;

    if (timer > 0) {
      setIsButtonDisabled(true);
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setIsButtonDisabled(false);
    }

    return () => {
      if (countdown) clearInterval(countdown);
    };
  }, [timer]);

  useEffect(() => {
    console.log("inputModalOpen", inputModalOpen);
    if (inputModalOpen === false && formData.getField("user_identity")) return;
    form.setField("user_identity", formData.getField("user_identity"));
    form.setField("token", "");
    form.removeError("token");
  }, [formData.getField("user_identity")]);

  const handleResendOTP = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setResendLoading(true);
    try {
      setTimer(60);
      setIsButtonDisabled(true);
      await intiateEmailLoginWithOtp(form);
    } catch (error) {
      console.log("check here error", error);
    } finally {
      isSubmittingRef.current = false;
      setResendLoading(false);
    }
  };

  const handleAfterLogin = async (res: any) => {
    dispatch(setBidderTokens({ access_token: res.access_token }));

    await fetch("/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        accessToken: res,
      }),
    });

    const user: any = await getUser();
    dispatch(setBidderUser(user));
    dispatch(setUser(user));
    if (user?.uuid) {
      const onboardingData: any = await getBidderOnboardingOfUser(user?.uuid);
      dispatch(setBidderOnboarding(onboardingData));
      dispatch(setOnboarding(onboardingData));
      try {
        await fetch("/api/2fa", { method: "POST" });
      } catch (e) {
        console.error("Failed to mark 2FA verified for today", e);
      }
      const redirectUri =
        (router.query.redirect_uri as string) ||
        (typeof window !== "undefined"
          ? localStorage.getItem("bidder_redirect_uri")
          : null) ||
        "/";
      if (redirectUri) {
        router.replace(redirectUri);
      } else {
        router.replace("/");
      }
    }

    // setInputModalOpen(true);
  };
  const handleVerification = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setLoading(true);
    try {
      console.log("form.validate()", form.validate(), form);
      form.value.user_identity = form.value.user_identity.trim().toLowerCase();
      if (form.validate()) {
        let isEmail = emailRegEx.test(form.value.user_identity);
        let isMobile = mobileNumberRegEx.test(form.value.user_identity);
        if (isEmail) {
          await emailLoginWithOtp(form).then(async (res: any) => {
            await handleAfterLogin(res);
          });
        } else if (isMobile) {
          await mobileLoginWithOtp(form).then(async (res: any) => {
            await handleAfterLogin(res);
          });
        }
      }
    } catch (error: any) {
      console.log("check here error", error);
    } finally {
      isSubmittingRef.current = false;
      setLoading(false);
    }
  };
  console.log(
    "data----->>>>",
    form.getField("user_identity"),
    inputModalOpen,
    guestUser,
    formData.getField("user_identity"),
  );
  return (
    <div className="h-full flex flex-col flex-grow">
      <div>
        <p
          className={`font-openSans font-semibold ${
            userLoggedIn ? "text-center" : ""
          } text-[24px] leading-8 text-black `}
        >
          {/* {guestUser?.isEmail ? "Verify your email" : "Verify your number"} */}
          Verify your login
        </p>
        <div className="flex space-x-2 mt-10 items-center">
          <p className="font-openSans font-normal text-web-body-lg leading-[22px] text-brand-textGrey">
            {/* OTP sent to{" "}
            <strong className="font-semibold">
              {form.value.user_identity}
            </strong> */}
            OTP sent to your registered credentials
          </p>
          <button
            className="underline"
            onClick={() => {
              setInputModalOpen(true);
              // setLoginModalOpen(true);
            }}
          >
            Back
          </button>
        </div>
        <p className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-bgBlack mt-8">
          Verify OTP
        </p>
        <div className="w-full flex  mt-2">
          <InputOTP
            value={form.getField("token")}
            onChange={(v: any) => form.setField("token", v)}
            maxLength={6}
            onKeyDown={(e: any) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleVerification();
              }
            }}
          >
            <InputOTPGroup className=" w-full gap-x-3">
              <InputOTPSlot
                className="bg-white border-none rounded-none h-[58px] w-10 sm:w-12"
                index={0}
              />
              <InputOTPSlot
                className="bg-white border-none rounded-none  h-[58px] w-10 sm:w-12"
                index={1}
              />
              <InputOTPSlot
                className="bg-white border-none rounded-none h-[58px] w-10 sm:w-12"
                index={2}
              />
              <InputOTPSlot
                className="bg-white border-none rounded-none h-[58px] w-10 sm:w-12"
                index={3}
              />
              <InputOTPSlot
                className="bg-white border-none rounded-none h-[58px] w-10 sm:w-12"
                index={4}
              />
              <InputOTPSlot
                className="bg-white border-none rounded-none h-[58px] w-10 sm:w-12"
                index={5}
              />
            </InputOTPGroup>
          </InputOTP>
        </div>
        {form.errors.get("token") ? (
          <p className="mt-2 text-sm text-red-500">
            {form.errors.get("token")[0]}
          </p>
        ) : null}

        <div className="mt-7 flex items-center font-openSans font-normal text-web-body-sm leading-[18px] text-[#717272] space-x-2">
          <p className="">Didn’t get OTP? </p>
          {timer > 0 ? (
            <p>Resend OTP in {timer} sec</p>
          ) : (
            <button
              className="underline"
              onClick={handleResendOTP}
              disabled={isButtonDisabled || resendLoading}
            >
              {resendLoading ? "Sending..." : "Resend OTP"}
            </button>
          )}
        </div>
      </div>
      <Button
        className="w-full mt-10 mb-4"
        disabled={loading}
        onClick={async () => await handleVerification()}
      >
        {loading ? "Verifying..." : "Next"}
      </Button>
    </div>
  );
}
